<template>
  <div class="msp-workout">
  <div class="msp-esporta-garmin">
    <v-progress-linear
    indeterminate
    v-show="isLoading"
    color="var(--col-msp)"
    ></v-progress-linear>
    
    <v-card outlined class="my-2" v-if="!garmin.annullato && !garmin.esportato">
        <v-card-title>Invia a Garmin Connect</v-card-title>
        <v-card-text>
            <div class="my-2" v-if="garmin.autorizzato"><v-btn block  @click="inviaGarminSingolo(allenamento.calendario_id)" color="primary">Solo questo allenamento</v-btn></div>
            <div class="my-2" v-if="garmin.autorizzato"><v-btn block  @click="inviaGarminSettimana(allenamento.data)" color="primary">7 giorni dal {{formatDate(allenamento.data)}}</v-btn></div>
            <div v-else class="my-2"><v-btn block  @click="autorizzaGarmin()" color="primary">Connetti Garmin</v-btn></div>
        </v-card-text>
    </v-card>
    <v-alert
    v-model="garmin.annullato"
    :type="message.type"
    outlined
    colored-border
    >
        <span v-html="message.text">
    </span>
    <div v-if="garmin.needsTest">
        <v-btn @click="addTest" color="primary">Aggiungi test</v-btn>
    </div>
    </v-alert>
    <v-alert
    v-model="garmin.esportato"
    type="success"
    >
    Inviato a Garmin Connect
    </v-alert>
    
    <v-card outlined class="my-2" v-if="allenamento.sport_id===2 && !zwo.esportato">
        <v-card-title>File ZWO</v-card-title>
        <v-card-text ><v-btn block @click="scaricaZwo()" color="primary">Esporta questo allenamento</v-btn></v-card-text>
    </v-card>
    <template v-else >
    <v-alert
    v-model="zwo.esportato"
    type="success"
    >
    File ZWO creato
    </v-alert>

<a v-if="zwo.url" :href="zwo.url" target="_blank">scarica file ZWO</a>
    </template>

  <v-alert
  v-model="showMessage"
  :type="message.type"
  dismissible
  >
  {{message.text}}
</v-alert>

</div>

</div>




    
</template>

<script>
import _api from "@mixins/api.js";
import env from "@mixins/environment.js"
import funzioni from "@src/js/vue/mixins/allenamentoCalcoli.js"
import {inviaGarmin, needsTest} from '@lib/garminMessages.js';

const component = {
  mixins: [
    env,
    funzioni,
  ],
  props: { 
      'allenamento': {
          type: Object,
      }
  },

  data() {
      return {
          showMessage: false,
          garmin: {
              autorizzato: false,
              annullato: false,
              esportato: false,
              oauth_token: null,
              needsTest: false,
              oldestDate: null,
          },
          zwo: {
              esportato: false,
              url: null,
          },
          message: {
              type: 'success',
              text: '',
          },
          authWindow: null,
          isLoading: false,
          isCompleted: false,
      }
  },
  computed: {
  },
  mounted() {

    this.verificaAutorizzazioneGarmin();

    window.addEventListener("message", (event) => {
      if (!this._popupWorkout) {
        return;
      }
      if (event.origin !== window.location.origin)
      {
        // return;

      }

      if (event.data === 'MSP_AUTH_GARMIN') {
        this._popupWorkout.close();
        this.garmin.autorizzato = true;
      }
      if (event.data === 'MSP_AUTH_ERROR') {
        this._popupWorkout.close();
        this.garmin.autorizzato = false;
      }
      if (event.data === 'MSP_SENT_GARMIN') {
        this._popupWorkout.close();
        this.garmin.esportato = true;
      }

      // ...
    }, false);


  },
  methods: {
      addTest: async function () {
          this.$store.dispatch("calendario/setDialog",true);
          this.$router.push({
              path: "/calendario/test/add",
              query: {
                  sport_id: this.allenamento.sport_id,
                  date: this.garmin.oldestDate,
              }
          });
      },
      setMessage: function (text, type) {
          this.showMessage = true;
              this.message = {
                "text": text,
                "type":type
              };
        },
        setFile: function (type, filename) {
            const endpoint = "https://app.coachpeaking.com/download.php?path=";
            this[type].url = endpoint+filename;
        },
        scaricaZwo: async function () {
            const filename = await this.esportaZwo();
            if (!filename) {
                this.erroreZwo();
            } else {
                this.setFile("zwo",filename);
                this.downloadZwo(filename);
            }
        },
        erroreZwo: function () {
              const message = {
                "text": "Non posso scaricare il file",
                "type": "error"
              };
              this.setMessage(message.text, message.type);
        },
        downloadZwo: function (filename) {
              this.zwo.esportato = true;
                const url = this.api_base_url
                    +"/download.php?path="+filename;
              window.open(url);
            },
      esportaZwo: function () {
        return new Promise((resolve)=>{
        const url = this.api_base_url
            +"/api/v2/workout.php?zwo"
            +"&calendario_id="+this.allenamento.calendario_id;
        _api(url, "GET")
        .then((result)=>{
            this.isLoading = false;
            if (result.success) {
              resolve(result.data);
            } else {
              resolve(false);
            }
        })
        .catch(()=>{
            this.isLoading = false;
            resolve(false);
          });
      });

          },
      esportaErg: function () {},

    checkTokenGarminExport: async function () {
      this.isLoading = true;

      return new Promise((resolve, reject)=>{

        const url = this.api_base_url+"/api/v2/workout.php?token";

        _api(url, "GET")
        .then((result)=>{
            this.isLoading = false;
            if (result.success) {
              resolve(result.data);
            } else {
              resolve(false);
            }
        })
        .catch((error)=>{
            this.isLoading = false;
            reject(error);
          })
      });
    },

    inviaGarminSettimana: async function (giorno) {
        let data = {
            'da': giorno
        }
        return this.inviaGarmin('settimana', data);
    },

    inviaGarminSingolo: async function () {
        let data = {
            calendario_id: this.allenamento.calendario_id
        }
        return this.inviaGarmin('singolo', data);
    },

    needsTest: needsTest,

    inviaGarmin: async function (type = "singolo", data) {
        this.isLoading = true;
        const result = await inviaGarmin(type,data);

        // Array di errori
        // date: String (es. "2025-01-31")
        // errors: Array di codici errore (es. ["NOZONE", "EMPTYJSON"])
        const errors = result.message.errors;

        const needsTest = this.needsTest(errors);
        this.garmin.needsTest = needsTest.hasNoZone;
        this.garmin.oldestDate =  needsTest.oldestDate;

        this.isLoading = false;
        if (!result.message.type==='error') {
            this.garmin.esportato = true;
            this.isCompleted = true;
        } else {
            this.garmin.esportato = false;
            this.garmin.annullato = true;
        }
        this.message = result.message;
        return result.data;
    },

    verificaAutorizzazioneGarmin: async function () {
      this.isLoading = true;
      let token = await this.checkTokenGarminExport();
      this.garmin.oauth_token = token;
      if (token) {
        this.isLoading = false;
        this.garmin.autorizzato = true;
      } else {
        this.isLoading = false;
        this.garmin.autorizzato = false;
      }
    },

    autorizzaGarmin: function () {
      // Ingresso unico del collegamento device (connection/authorize.php), come Connessioni.vue.
      const url = this.api_base_url + "/connection/authorize.php?provider=garmin&origin=" + encodeURIComponent(window.location.origin);
      const windowFeatures = "menubar=no,location=no,resizable=no,scrollbars=yes,status=no,width=400,height=600";
      this._popupWorkout = window.open(url, 'popupWorkout', windowFeatures);
    },

  }
}
export default component;
</script>

<style lang="scss">
.msp-esporta-garmin {
  .buttons-container {
    background: var(--col-grigio-scuro);
  }
  .v-progress-linear {
    margin-bottom: 10px;
  }
  .v-alert__content {
      white-space: pre-line;
  }
}
</style>
